// extracted by mini-css-extract-plugin
export var locationsContainer = "_z1-2";
export var locationsTextContainer = "_z1-1";
export var mapContainer = "_z1-0";